type FeedbackResolutionNoteProps = {
  value: string;
  onChange: (value: string) => void;
};

export function FeedbackResolutionNote({
  value,
  onChange,
}: FeedbackResolutionNoteProps) {
  return (
    <section>
      <label
        htmlFor="feedback-resolution-note"
        className="mb-1 block text-xs font-semibold uppercase tracking-wide text-gray-500"
      >
        Resolution note
      </label>
      <textarea
        id="feedback-resolution-note"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        rows={4}
        maxLength={4000}
        className="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 placeholder-gray-400 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
        placeholder="What changed, or why this feedback is resolved?"
      />
    </section>
  );
}
